import type { SVGProps } from '@/types/common.types';

const SubscriptionOnlineTvSVG = (props: SVGProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="114"
      height="26"
      viewBox="0 0 114 26"
      fill="none"
      {...props}
    >
      <path
        d="M21.5093 2.98669H4.48549C3.20329 2.98669 2.16406 4.02592 2.16406 5.30812V16.2421C2.16406 17.5243 3.20329 18.5635 4.48549 18.5635H21.5093C22.7915 18.5635 23.8307 17.5243 23.8307 16.2421V5.30812C23.8307 4.02592 22.7915 2.98669 21.5093 2.98669ZM15.3126 11.7779L13.067 13.365C12.2538 13.94 11.1302 13.3581 11.1302 12.3622V9.18878C11.1302 8.19288 12.2538 7.61098 13.067 8.18592L15.3126 9.773C16.0052 10.2613 16.0052 11.2881 15.3126 11.7779Z"
        fill="url(#paint0_linear_14572_20793)"
      />
      <path
        d="M18.8949 21.6855C18.1691 21.3497 16.907 21.1021 15.388 20.9728V19.9561H10.6059V20.9728C9.0869 21.1013 7.82482 21.3489 7.09899 21.6855C6.75 21.8465 6.59833 22.2605 6.76006 22.6094C6.92024 22.9577 7.33345 23.1101 7.68399 22.9484C8.41833 22.6094 10.3467 22.2659 12.997 22.2659C15.6473 22.2659 17.5756 22.6087 18.3099 22.9484C18.4043 22.9925 18.5042 23.0134 18.6017 23.0134C18.8648 23.0134 19.117 22.864 19.2339 22.6094C19.3964 22.2605 19.2439 21.8465 18.8949 21.6855Z"
        fill="url(#paint1_linear_14572_20793)"
      />
      <path
        d="M40.9756 13C40.9756 14.2852 40.7323 15.3745 40.2458 16.2681C39.7592 17.1616 39.1005 17.8403 38.2696 18.3042C37.4425 18.7681 36.5143 19 35.485 19C34.452 19 33.5219 18.7662 32.6948 18.2985C31.8676 17.8308 31.2108 17.1521 30.7242 16.2624C30.2414 15.3688 30 14.2814 30 13C30 11.7148 30.2414 10.6255 30.7242 9.73194C31.2108 8.8384 31.8676 8.1597 32.6948 7.69582C33.5219 7.23194 34.452 7 35.485 7C36.5143 7 37.4425 7.23194 38.2696 7.69582C39.1005 8.1597 39.7592 8.8384 40.2458 9.73194C40.7323 10.6255 40.9756 11.7148 40.9756 13ZM38.1349 13C38.1349 12.2395 38.0282 11.597 37.8149 11.0722C37.6053 10.5475 37.3021 10.1502 36.9054 9.88023C36.5124 9.61027 36.0389 9.47529 35.485 9.47529C34.9348 9.47529 34.4614 9.61027 34.0646 9.88023C33.6679 10.1502 33.3629 10.5475 33.1495 11.0722C32.9399 11.597 32.8351 12.2395 32.8351 13C32.8351 13.7605 32.9399 14.403 33.1495 14.9278C33.3629 15.4525 33.6679 15.8498 34.0646 16.1198C34.4614 16.3897 34.9348 16.5247 35.485 16.5247C36.0389 16.5247 36.5124 16.3897 36.9054 16.1198C37.3021 15.8498 37.6053 15.4525 37.8149 14.9278C38.0282 14.403 38.1349 13.7605 38.1349 13Z"
        fill="url(#paint2_linear_14572_20793)"
      />
      <path
        d="M52.3835 7.1597V18.8403H50.0256L45.4501 12.0989H45.3771V18.8403H42.5981V7.1597H44.9897L49.5147 13.8897H49.6102V7.1597H52.3835Z"
        fill="url(#paint3_linear_14572_20793)"
      />
      <path
        d="M54.1309 18.8403V7.1597H56.9099V16.5475H61.6932V18.8403H54.1309Z"
        fill="url(#paint4_linear_14572_20793)"
      />
      <path
        d="M65.9108 7.1597V18.8403H63.1318V7.1597H65.9108Z"
        fill="url(#paint5_linear_14572_20793)"
      />
      <path
        d="M77.4408 7.1597V18.8403H75.0829L70.5073 12.0989H70.4344V18.8403H67.6554V7.1597H70.047L74.572 13.8897H74.6674V7.1597H77.4408Z"
        fill="url(#paint6_linear_14572_20793)"
      />
      <path
        d="M79.1882 18.8403V7.1597H87.2052V9.45247H81.9672V11.8479H86.7953V14.1464H81.9672V16.5475H87.2052V18.8403H79.1882Z"
        fill="url(#paint7_linear_14572_20793)"
      />
      <path
        d="M91.966 9.45247V7.1597H101.684V9.45247H98.1976V18.8403H95.4579V9.45247H91.966Z"
        fill="url(#paint8_linear_14572_20793)"
      />
      <path
        d="M105.652 7.1597L108.223 15.7148H108.319L110.89 7.1597H114L110.121 18.8403H106.421L102.542 7.1597H105.652Z"
        fill="url(#paint9_linear_14572_20793)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_14572_20793"
          x1="1.87981"
          y1="-3.91665"
          x2="-12.1399"
          y2="42.9629"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFFF4D" />
          <stop offset="1" stopColor="#F46600" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_14572_20793"
          x1="6.52996"
          y1="18.6011"
          x2="5.52866"
          y2="28.5242"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFFF4D" />
          <stop offset="1" stopColor="#F46600" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_14572_20793"
          x1="28.898"
          y1="1.68182"
          x2="26.5681"
          y2="40.8883"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFFF4D" />
          <stop offset="1" stopColor="#F46600" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_14572_20793"
          x1="28.898"
          y1="1.68182"
          x2="26.5681"
          y2="40.8883"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFFF4D" />
          <stop offset="1" stopColor="#F46600" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_14572_20793"
          x1="28.898"
          y1="1.68182"
          x2="26.5681"
          y2="40.8883"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFFF4D" />
          <stop offset="1" stopColor="#F46600" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_14572_20793"
          x1="28.898"
          y1="1.68182"
          x2="26.5681"
          y2="40.8883"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFFF4D" />
          <stop offset="1" stopColor="#F46600" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_14572_20793"
          x1="28.898"
          y1="1.68182"
          x2="26.5681"
          y2="40.8883"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFFF4D" />
          <stop offset="1" stopColor="#F46600" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_14572_20793"
          x1="28.898"
          y1="1.68182"
          x2="26.5681"
          y2="40.8883"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFFF4D" />
          <stop offset="1" stopColor="#F46600" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_14572_20793"
          x1="28.898"
          y1="1.68182"
          x2="26.5681"
          y2="40.8883"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFFF4D" />
          <stop offset="1" stopColor="#F46600" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_14572_20793"
          x1="28.898"
          y1="1.68182"
          x2="26.5681"
          y2="40.8883"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFFF4D" />
          <stop offset="1" stopColor="#F46600" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default SubscriptionOnlineTvSVG;
